// extracted by extract-css-chunks-webpack-plugin
module.exports = {"noWrap":"noWrap_FJw5Z"};